import React from 'react';
import { observer } from 'mobx-react';
import MarkdownContent from './MarkdownContent';
import { Card, CardTitle, EmptyState } from './CompanyPage.styles';

const DifferentiatorsView = observer(({ differentiators }) => {
  if (!differentiators || differentiators.length === 0) {
    return <EmptyState>No differentiators have been added yet.</EmptyState>;
  }

  return (
    <>
      {differentiators.map((diff, i) => (
        <Card key={i}>
          <CardTitle style={{ marginBottom: 16 }}>Differentiator #{i + 1}</CardTitle>
          <MarkdownContent markdown={diff} />
        </Card>
      ))}
    </>
  );
});

export default DifferentiatorsView;
